import { render, staticRenderFns } from "./DisplaySchools.vue?vue&type=template&id=8f510780&scoped=true&"
import script from "./DisplaySchools.vue?vue&type=script&lang=ts&"
export * from "./DisplaySchools.vue?vue&type=script&lang=ts&"
import style0 from "./DisplaySchools.vue?vue&type=style&index=0&id=8f510780&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f510780",
  null
  
)

export default component.exports